/* eslint-disable no-undefined */
import React, { createContext, useCallback, useContext, useState } from 'react';

import { ExternalSubmissionThemeProvider } from './ExternalSubmissionThemeContext';

export const initialState = {
	isSubmitting: false,
	isSubmitSuccess: false,
	isSubmitError: false,
	isSaving: false,
	isSaveSuccess: false,
	isSaveError: false,
};

const ExternalSubmissionStateContext = createContext(initialState);
const ExternalSubmissionUpdaterContext = createContext();

function useExternalSubmissionState() {
	const status = useContext(ExternalSubmissionStateContext);

	if (status === undefined) {
		throw new Error('useExternalSubmissionState must be used within a ExternalSubmissionProvider');
	}

	return status;
}

function useExternalSubmissionUpdater() {
	const setStatus = useContext(ExternalSubmissionUpdaterContext);

	if (setStatus === undefined) {
		throw new Error(
			'useExternalSubmissionUpdater must be used within a ExternalSubmissionProvider',
		);
	}

	const showStatus = useCallback(
		({
			isSubmitting = false,
			isSubmitSuccess = false,
			isSubmitError = false,
			isSaving = false,
			isSaveSuccess = false,
			isSaveError = false,
		}) =>
			setStatus({
				isSubmitting,
				isSubmitSuccess,
				isSubmitError,
				isSaving,
				isSaveSuccess,
				isSaveError,
			}),
		[setStatus],
	);

	return { showStatus };
}

function ExternalSubmissionProvider({ state = initialState, children }) {
	const [status, setStatus] = useState(state);

	return (
		<ExternalSubmissionThemeProvider>
			<ExternalSubmissionStateContext.Provider value={status}>
				<ExternalSubmissionUpdaterContext.Provider value={setStatus}>
					{children}
				</ExternalSubmissionUpdaterContext.Provider>
			</ExternalSubmissionStateContext.Provider>
		</ExternalSubmissionThemeProvider>
	);
}

export { ExternalSubmissionProvider, useExternalSubmissionState, useExternalSubmissionUpdater };
